import { menuTranslations } from "../../menu/i18n";
const submenuTranslation = menuTranslations().apps;
const buyMenuConf = [
    [
        {
            app: "buy",
            entry: "workspace",
            icon: "deal",
            text: submenuTranslation.buy.submenus.workspace,
            service: "workspace",
            path: "",
        },
        {
            app: "buy",
            entry: "recordedOffers",
            icon: "offer_default",
            text: submenuTranslation.buy.submenus.recordedOffers,
            service: "offer",
            path: "buyer",
        },
    ],
    [
        {
            app: "buy",
            entry: "contactManager",
            icon: "contacts",
            text: submenuTranslation.buy.submenus.contactManager,
            service: "offer",
            path: "contact-manager",
        },
        {
            app: "buy",
            entry: "monitors",
            icon: "monitor",
            text: submenuTranslation.buy.submenus.monitors,
            service: "monitor",
            path: "",
            toolsPopup: true,
        },
    ],
];
const adminMenuConf = [
    [
        {
            app: "admin",
            entry: "companySettings",
            icon: "settings_config",
            text: submenuTranslation.admin.submenus.companySettings,
            service: "lana",
            path: "company/settings",
            scopeRequirement: { service: "companyadmin", scope: "CA" },
        },
        {
            app: "admin",
            entry: "companyUsers",
            icon: "user_group",
            text: submenuTranslation.admin.submenus.companyUsers,
            service: "lana",
            path: "company/members",
            scopeRequirement: { service: "companyadmin", scope: "CA" },
        },
        {
            app: "admin",
            entry: "products",
            icon: "usage",
            text: submenuTranslation.admin.submenus.products,
            service: "lana",
            path: "company/products-statistics",
            scopeRequirement: { service: "companyadmin", scope: "CA" },
        },
    ],
    [
        {
            app: "admin",
            entry: "apiAdmin",
            icon: "key",
            text: submenuTranslation.admin.submenus.apiAdmin,
            service: "lana",
            path: "company/api-admin",
            scopeRequirement: { service: "api", scope: "CA" },
        },
    ],
];
const accountMenuConf = [
    [
        {
            app: "account",
            entry: "profile",
            icon: "profile_male",
            text: submenuTranslation.account.submenus.profile,
            service: "lana",
            path: "user/profile",
        },
        {
            app: "account",
            entry: "security",
            icon: "security",
            text: submenuTranslation.account.submenus.security,
            service: "lana",
            path: "user/security",
        },
    ],
];
const helionMenuConf = [
    [
        {
            app: "helion",
            entry: "home",
            icon: "home",
            text: submenuTranslation.helion.submenus["home"],
            service: "helion",
            path: "",
        },
        {
            app: "helion",
            entry: "inProgress",
            icon: "workspace",
            text: submenuTranslation.helion.submenus["inProgress"],
            service: "helion",
            path: "",
        },
        {
            app: "helion",
            entry: "archive",
            icon: "archive",
            text: submenuTranslation.helion.submenus["archive"],
            service: "helion",
            path: "",
        },
    ],
    [
        {
            app: "helion",
            entry: "notifications",
            icon: "notifications",
            text: submenuTranslation.helion.submenus["notifications"],
            service: "helion",
            path: "",
        },
        {
            app: "helion",
            entry: "tasks",
            icon: "tasks",
            text: submenuTranslation.helion.submenus["tasks"],
            service: "helion",
            path: "",
        },
    ],
    [
        {
            app: "helion",
            entry: "calculations",
            icon: "calculation",
            text: submenuTranslation.helion.submenus["calculations"],
            service: "helion",
            path: "",
        },
        {
            app: "helion",
            entry: "settings",
            icon: "settings_options",
            text: submenuTranslation.helion.submenus["settings"],
            service: "helion",
            path: "",
        },
    ],
];
const valuationMenuConf = [
    [
        {
            app: "valuation",
            entry: "home",
            icon: "home",
            text: submenuTranslation.valuation.submenus["home"],
            service: "valuation",
            path: "",
        },
    ],
];
const locationAnalyticsMenuConf = [
    [
        {
            app: "locationAnalytics",
            entry: "quickstart",
            icon: "quick_start",
            text: submenuTranslation.locationAnalytics.submenus["quickstart"],
            service: "lana",
            path: "quickstart",
            scopeRequirement: {
                service: "lana",
                scope: {
                    scopeConditions: "OR",
                    scopes: ["A", "C", "MD"],
                },
            },
            singleAppNavigation: true,
        },
        {
            app: "locationAnalytics",
            entry: "locationAssessment",
            module: "comparables",
            icon: "price_trend",
            text: submenuTranslation.locationAnalytics.submenus["locationAssessment"]
                .modules["comparables"],
            service: "lana",
            path: "comparables",
            scopeRequirement: {
                service: "lana",
                scope: {
                    scopeConditions: "AND_NOT",
                    requiredScope: "C",
                    absentScopes: ["A"],
                },
            },
            singleAppNavigation: true,
        },
        {
            app: "locationAnalytics",
            entry: "locationAssessment",
            module: "poiExplorer",
            icon: "marker",
            text: submenuTranslation.locationAnalytics.submenus["locationAssessment"]
                .modules["poiExplorer"],
            service: "lana",
            path: "poiexplorer",
            scopeRequirement: {
                service: "lana",
                scope: {
                    scopeConditions: "AND_NOT",
                    requiredScope: "POI",
                    absentScopes: ["A"],
                },
            },
            singleAppNavigation: true,
        },
        {
            app: "locationAnalytics",
            entry: "locationAssessment",
            module: "marketdata",
            icon: "market_data",
            text: submenuTranslation.locationAnalytics.submenus["locationAssessment"]
                .modules["marketdata"],
            service: "lana",
            path: "districtdata",
            scopeRequirement: {
                service: "lana",
                scope: {
                    scopeConditions: "AND_NOT",
                    requiredScope: "MD",
                    absentScopes: ["A"],
                },
            },
            singleAppNavigation: true,
        },
        {
            app: "locationAnalytics",
            entry: "locationAssessment",
            module: "specialMaps",
            icon: "map",
            text: submenuTranslation.locationAnalytics.submenus["locationAssessment"]
                .modules["specialMaps"],
            service: "lana",
            path: "specialmaps",
            scopeRequirement: {
                service: "lana",
                scope: {
                    scopeConditions: "AND_NOT",
                    requiredScope: "SM",
                    absentScopes: ["A"],
                },
            },
            singleAppNavigation: true,
        },
        {
            app: "locationAnalytics",
            entry: "locationAssessment",
            icon: "indication_location",
            text: submenuTranslation.locationAnalytics.submenus["locationAssessment"]
                .name,
            service: "lana",
            path: "assessments",
            scopeRequirement: { scope: "A", service: "lana" },
            modules: [
                {
                    module: "dashboard",
                    scopeRequirement: { scope: "A", service: "lana" },
                    icon: "dashboard",
                    text: submenuTranslation.locationAnalytics.submenus["locationAssessment"].modules["dashboard"],
                    path: "dashboard",
                },
                {
                    module: "assessment",
                    scopeRequirement: { scope: "A", service: "lana" },
                    icon: "statistics",
                    text: submenuTranslation.locationAnalytics.submenus["locationAssessment"].modules["assessment"],
                    path: "assessments",
                },
                {
                    module: "comparables",
                    scopeRequirement: { scope: "C", service: "lana" },
                    icon: "price_trend",
                    text: submenuTranslation.locationAnalytics.submenus["locationAssessment"].modules["comparables"],
                    path: "comparables",
                },
                {
                    module: "poiExplorer",
                    scopeRequirement: { scope: "POI", service: "lana" },
                    icon: "marker",
                    text: submenuTranslation.locationAnalytics.submenus["locationAssessment"].modules["poiExplorer"],
                    path: "poiexplorer",
                },
                {
                    module: "marketdata",
                    scopeRequirement: { scope: "MD", service: "lana" },
                    icon: "market_data",
                    text: submenuTranslation.locationAnalytics.submenus["locationAssessment"].modules["marketdata"],
                    path: "districtdata",
                },
                {
                    module: "specialMaps",
                    scopeRequirement: { scope: "SM", service: "lana" },
                    icon: "map",
                    text: submenuTranslation.locationAnalytics.submenus["locationAssessment"].modules["specialMaps"],
                    path: "specialmaps",
                },
                {
                    module: "rentindex",
                    scopeRequirement: { scope: "A", service: "lana" },
                    icon: "prices_rent_index",
                    text: submenuTranslation.locationAnalytics.submenus["locationAssessment"].modules["rentindex"],
                    path: "rentindex",
                },
            ],
            singleAppNavigation: true,
        },
        {
            app: "locationAnalytics",
            entry: "profileManager",
            icon: "scoremanager",
            text: submenuTranslation.locationAnalytics.submenus["profileManager"],
            service: "lana",
            path: "profiles",
            scopeRequirement: { scope: "P", service: "lana" },
            singleAppNavigation: true,
            toolsPopup: true,
        },
        {
            app: "locationAnalytics",
            entry: "locationExplorer",
            icon: "my_location",
            text: submenuTranslation.locationAnalytics.submenus["locationExplorer"],
            service: "lana",
            path: "explorer",
            scopeRequirement: {
                service: "lana",
                scope: {
                    scopeConditions: "AND_NOT",
                    requiredScope: "E",
                    absentScopes: ["LS", "RM"],
                },
            },
            singleAppNavigation: true,
            toolsPopup: true,
        },
        {
            app: "locationAnalytics",
            entry: "locationSelector",
            icon: "my_location",
            text: submenuTranslation.locationAnalytics.submenus["locationSelector"],
            service: "lana",
            path: "locationselector",
            scopeRequirement: { scope: "LS", service: "lana" },
            singleAppNavigation: true,
            toolsPopup: true,
        },
        {
            app: "locationAnalytics",
            entry: "ratingManager",
            icon: "my_location",
            text: submenuTranslation.locationAnalytics.submenus["ratingManager"],
            service: "lana",
            path: "rating-manager",
            scopeRequirement: { scope: "RM", service: "lana" },
            singleAppNavigation: true,
            toolsPopup: true,
        },
        {
            app: "locationAnalytics",
            entry: "privateData",
            icon: "private_poi",
            text: submenuTranslation.locationAnalytics.submenus["privateData"],
            service: "lana",
            path: "privatedata",
            scopeRequirement: { scope: "PD", service: "lana" },
            singleAppNavigation: true,
            toolsPopup: true,
        },
    ],
];
const portfolioAnalysisConf = [
    [
        {
            app: "portfolioAnalyse",
            entry: "inProgress",
            icon: "edit",
            text: submenuTranslation.portfolioAnalyse.submenus.inProgress,
            service: "portfolio-analyse",
            path: "",
        },
    ],
    [
        {
            app: "portfolioAnalyse",
            entry: "calculationMethod",
            icon: "calculation",
            text: submenuTranslation.portfolioAnalyse.submenus.calculationMethod,
            service: "portfolio-analyse",
            path: "calculationMethod",
        },
    ],
];
const phantomMenuConf = [
    [
        {
            app: "phantomMenu",
            entry: "content",
            text: "Phantom Menu Content 1",
            icon: "person",
            service: "lana",
        },
        {
            app: "phantomMenu",
            entry: "content1",
            text: "Phantom Menu Content 2",
            icon: "person",
            service: "lana",
        },
        {
            app: "phantomMenu",
            entry: "content2",
            text: "Phantom Menu Content 3",
            icon: "person",
            service: "lana",
        },
        {
            app: "phantomMenu",
            entry: "content3",
            text: "Phantom Menu Content 4",
            icon: "person",
            service: "lana",
        },
        {
            app: "phantomMenu",
            entry: "content4",
            text: "Phantom Menu Content 5",
            icon: "person",
            service: "lana",
        },
        {
            app: "phantomMenu",
            entry: "content5",
            text: "Phantom Menu Content 6",
            icon: "person",
            service: "lana",
            toolsPopup: true,
        },
        {
            app: "phantomMenu",
            entry: "content6",
            text: "Phantom Menu Content 7",
            icon: "person",
            service: "lana",
            toolsPopup: true,
        },
        {
            app: "phantomMenu",
            entry: "content7",
            text: "Phantom Menu Content 8",
            icon: "person",
            service: "lana",
            toolsPopup: true,
        },
    ],
];
export const appLocationConfig = {
    buy: buyMenuConf,
    admin: adminMenuConf,
    account: accountMenuConf,
    valuation: valuationMenuConf,
    helion: helionMenuConf,
    locationAnalytics: locationAnalyticsMenuConf,
    portfolioAnalyse: portfolioAnalysisConf,
    phantomMenu: phantomMenuConf,
    "???": [],
};
//# sourceMappingURL=app-location-config.js.map